import { render, staticRenderFns } from "./_ApplicationWorkflowDocumentation.vue?vue&type=template&id=2b9a4ffb&"
import script from "./_ApplicationWorkflowDocumentation.vue?vue&type=script&lang=ts&"
export * from "./_ApplicationWorkflowDocumentation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports